import { Icons } from "widgets";

import { CAPABILITY, EXT_APP_MODULES, LICENSE_MODULE } from "@/settings/settings.ts";
import type { IPanelLink } from "@/ui-modules/dashboard/QuicklinkDashboardCard.tsx";

export const visualizerData: IPanelLink[][] = [
  [
    {
      title: "Genome Viewer",
      url: "/visualizer/genome",
      description: "Interactively visualize genomic data",
      imgPath: Icons.Tiles.GenomeViewer,
      active: true,
      licenseModule: LICENSE_MODULE.EXPLORER,
    },
    {
      title: "Sequence Viewer",
      url: "/visualizer/sequence",
      description: "Interactively visualize sequence data",
      imgPath: Icons.Tiles.SequenceViewer,
      active: true,
      licenseModule: LICENSE_MODULE.EXPLORER,
    },
    {
      title: "Analytical Data",
      url: "/visualizer/data",
      description: "View profile plots with quantitative data",
      imgPath: Icons.Tiles.AnalyticalDataViewer,
      active: true,
      licenseModule: LICENSE_MODULE.EXPLORER,
    },
    {
      title: "Processor",
      url: "/processor",
      description: "Build and execute automated workflows",
      imgPath: Icons.Tiles.Processor,
      active: true,
      licenseModule: EXT_APP_MODULES.PROCESSOR.id,
      capability: CAPABILITY.LAUNCH_PROCESSOR,
    },
  ],
  [
    {
      title: "Classic " + EXT_APP_MODULES.PROCESSOR.name,
      jnlpModuleId: EXT_APP_MODULES.PROCESSOR.id,
      description: "Build and execute NGS workflows",
      imgPath: Icons.Tiles.Processor,
      active: true,
      licenseModule: EXT_APP_MODULES.PROCESSOR.id,
      capability: CAPABILITY.LAUNCH_CLASSIC_PROCESSOR,
    },
    {
      title: EXT_APP_MODULES.ANALYST.name,
      jnlpModuleId: EXT_APP_MODULES.ANALYST.id,
      description: "Statistical analysis and data visualization",
      imgPath: Icons.Tiles.Analyst,
      active: true,
      licenseModule: EXT_APP_MODULES.ANALYST.id,
      capability: CAPABILITY.LAUNCH_ANALYST,
    },
    {
      title: EXT_APP_MODULES.ARRAY.name,
      jnlpModuleId: EXT_APP_MODULES.ARRAY.id,
      description: "Build and execute microarray workflows",
      imgPath: Icons.Tiles.Array,
      active: true,
      licenseModule: EXT_APP_MODULES.ARRAY.id,
      capability: CAPABILITY.LAUNCH_ARRAY,
    },
  ],
];
